import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-info-panel-section',
  standalone: true,
  imports: [],
  templateUrl: './info-panel-section.component.html',
  styleUrl: './info-panel-section.component.css',
})
export class InfoPanelSectionComponent {
  /** Optional heading. When omitted, no header is rendered — just the grid. */
  @Input() title?: string;
  @Input() columns = 2;

  get gridColumns(): string {
    return `repeat(${this.columns}, 1fr)`;
  }
}
